<template>
	<div class="FreezeRecords">
		<el-row type="flex" justify="space-between" align="top">
			<div>
				<el-button type="primary" @click="freezeRecordFn('addRecord')"
					>新增</el-button
				>
			</div>

			<el-form inline :model="formScreen" ref="formScreen">
				<el-form-item prop="searchString">
					<el-input
						v-model="formScreen.searchString"
						placeholder="单据号、店铺名称"
						style="width:400px"
					></el-input>
				</el-form-item>
				<el-form-item size="large">
					<el-button type="primary" @click="getTableList()"
						>搜索</el-button
					>
					<el-button type="primary" @click="reset('formScreen')"
						>重置</el-button
					>
				</el-form-item>
			</el-form>
		</el-row>
		<el-table
			:data="listTable"
			border
			style="width: 100%"
			:cell-style="{ textAlign: 'center' }"
			:header-cell-style="{ textAlign: 'center' }"
		>
			<el-table-column
				prop="freezeNumber"
				label="单据号"
			></el-table-column>
			<el-table-column prop="shopName" label="冻结店铺"></el-table-column>
			<el-table-column
				prop="createTime"
				label="创建时间"
			></el-table-column>
			<el-table-column
				prop="countryName"
				label="冻结站点"
			></el-table-column>
			<el-table-column
				prop="freezeTime"
				label="冻结时间"
			></el-table-column>
			<el-table-column prop="freezeAmount" label="冻结金额">
				<template slot-scope="scope">
					<div
						v-if="
							scope.row.freezeAmount &&
								scope.row.freezeCurrencyCode
						"
					>
						{{
							`${scope.row.freezeAmount}（${scope.row.freezeCurrencyCode}）`
						}}
					</div>
				</template>
			</el-table-column>
			<el-table-column label="凭证图片">
				<template slot-scope="scope">
					<!-- <el-popover trigger="hover" placement="right" v-if="scope.row.repayImage">
                        <img :src="scope.row.repayImage.url" class="prduct_img" alt />
                        <div class="scope_img" slot="reference">
                            <img :src="scope.row.repayImage.url"/>
                        </div>
                    </el-popover> -->
					<div
						class="demo-image__preview"
						v-if="scope.row.repayImage"
					>
						<el-image
							style="width: 100px; height: 100px"
							:src="scope.row.repayImage.url"
							:preview-src-list="[scope.row.repayImage.url]"
						>
						</el-image>
					</div>
				</template>
			</el-table-column>
			<el-table-column
				prop="unfreezeTime"
				label="解冻时间"
			></el-table-column>
			<el-table-column prop="unfreezeAmount" label="解冻金额">
				<template slot-scope="scope">
					<div
						v-if="
							scope.row.unfreezeAmount &&
								scope.row.unfreezeCurrencyCode
						"
					>
						{{
							`${scope.row.unfreezeAmount}（${scope.row.unfreezeCurrencyCode}）`
						}}
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="date" label="操作" width="180">
				<template slot-scope="scope">
					<el-button
						type="primary"
						@click="freezeRecordFn('thawRecord', scope.row)"
						>解冻记录</el-button
					>
				</template>
			</el-table-column>
		</el-table>
		<el-row type="flex" justify="center">
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="page"
				:page-sizes="[20, 50, 100, 200, 300]"
				:page-size="size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
			></el-pagination>
		</el-row>
		<!-- 新增/冻结记录 -->
		<el-dialog
			top="30px"
			:title="freezeRecordTitle"
			:visible.sync="isFreezeRecordVisible"
			width="54%"
		>
			<el-form
				class="custom-dialog"
				:model="formRecord"
				ref="formRecord"
				label-width="120px"
				:rules="formRecordRules"
			>
				<el-form-item prop="sellerId" label="店铺选择：">
					<el-select
						class="width380"
						v-model="formRecord.sellerId"
						placeholder="请选择店铺"
						@change="seletChange"
						filterable
						clearable
						:disabled="freezeRecordDialog === 'thawRecord'"
					>
						<el-option
							v-for="item in listStorage"
							:key="item.id"
							:label="item.shop_name"
							:value="item.id"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="countrySellerId" label="站点选择：">
					<el-select
						class="width380"
						@change="countryChange"
						v-model="formRecord.countrySellerId"
						placeholder="请选择站点"
						:disabled="freezeRecordDialog === 'thawRecord'"
					>
						<el-option
							v-for="item in listSite"
							:key="item.shopId"
							:label="item.countryName"
							:value="item.shopId"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="freezeTimeString" label="冻结时间：">
					<el-date-picker
						class="width380"
						v-model="formRecord.freezeTimeString"
						type="datetime"
						placeholder="请选择日期"
						value-format="yyyy-MM-dd HH:mm:ss"
						:disabled="freezeRecordDialog === 'thawRecord'"
					></el-date-picker>
				</el-form-item>
				<el-form-item label="冻结币种(中)：">
					<!-- <el-input
						disabled
						class="width380"
						v-model="Chines"
					></el-input> -->
					<el-select class="width380" v-model="Chines" disabled>
						<el-option
							v-for="item in listExchangeRate"
							:key="item.currencyCode"
							:label="item.country"
							:value="item.currencyCode"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="冻结币种(英)：">
					<el-input
						disabled
						class="width380"
						v-model="formRecord.freezeCurrencyCode"
					></el-input>
				</el-form-item>
				<el-form-item prop="freezeAmount" label="冻结金额：">
					<el-input
						v-model="formRecord.freezeAmount"
						class="width380"
						placeholder="请输入冻结金额"
						:disabled="freezeRecordDialog === 'thawRecord'"
					></el-input>
				</el-form-item>
				<el-form-item label="凭证图片：" required>
					<el-upload
						ref="upload"
						multiple
						:action="action"
						list-type="picture-card"
						:on-preview="handlePictureCardPreview"
						:on-success="handleSuccess"
						:on-remove="handleRemove"
						:headers="customHeaders"
						v-if="freezeRecordDialog !== 'thawRecord'"
					>
						<i class="el-icon-plus"></i>
					</el-upload>
					<template
						v-else
						v-for="item in formRecord.uploadCertificates"
					>
						<img
							:src="item"
							:key="item"
							style="width: 148px;height: 148px;margin-right: 10px;"
						/>
					</template>
				</el-form-item>
			</el-form>
			<template v-if="freezeRecordDialog === 'thawRecord'">
				<el-divider content-position="left">解冻记录</el-divider>
				<el-form
					class="custom-dialog"
					:model="formUnfreeze"
					ref="formUnfreeze"
					label-width="120px"
					:rules="formUnfreezeRules"
				>
					<el-form-item prop="unfreezeTimeString" label="解冻时间：">
						<el-date-picker
							class="width380"
							v-model="formUnfreeze.unfreezeTimeString"
							type="datetime"
							placeholder="请选择日期"
							value-format="yyyy-MM-dd HH:mm:ss"
						></el-date-picker>
					</el-form-item>
					<el-form-item
						prop="unfreezeCurrencyCode"
						label="解冻币种："
					>
						<el-select
							class="width380"
							disabled
							v-model="formUnfreeze.unfreezeCurrencyCode"
							placeholder="请选择币种"
						>
							<el-option
								v-for="item in listExchangeRate"
								:key="item.currencyCode"
								:label="item.country"
								:value="item.currencyCode"
							></el-option>
						</el-select>
					</el-form-item>

					<el-form-item prop="freezeCurrencyCode" label="解结币种：">
						<el-input
							disabled
							class="width380"
							v-model="formRecord.freezeCurrencyCode"
						></el-input>
					</el-form-item>
					<el-form-item prop="unfreezeAmount" label="解冻金额：">
						<el-input
							v-model="formUnfreeze.unfreezeAmount"
							class="width380"
							placeholder="请输入冻结金额"
						></el-input>
					</el-form-item>
				</el-form>
			</template>
			<span slot="footer" class="dialog-footer">
				<el-button @click="freezeRecordDialog = ''">取 消</el-button>
				<el-button type="primary" @click="onSubmit" :loading="loading"
					>确 定</el-button
				>
			</span>
			<el-dialog :visible.sync="dialogVisible" append-to-body>
				<img width="100%" :src="dialogImageUrl" alt="" />
			</el-dialog>
		</el-dialog>
	</div>
</template>

<script>
import { ajaxPost, Baseurl } from '@/api/api/api'
export default {
	data() {
		return {
			Chines: '',
			UserInfo: {},
			loading: false,
			formScreen: {
				searchString: '',
			},
			formRecord: {
				sellerId: '',
				countrySellerId: '',
				freezeAmount: '',
				freezeTimeString: '',
				freezeCurrencyCode: '',
				uploadCertificates: [],
			},
			imgList: [],
			dialogImageUrl: '',
			dialogVisible: false,
			formUnfreeze: {
				id: 0,
				unfreezeAmount: '',
				unfreezeCurrencyCode: '',
				unfreezeTimeString: '',
			},
			formRecordRules: {
				sellerId: [
					{
						required: true,
						message: '请选择店铺',
						trigger: 'change',
					},
				],
				countrySellerId: [
					{
						required: true,
						message: '请选择站点',
						trigger: 'change',
					},
				],
				freezeTimeString: [
					{
						required: true,
						message: '请选择冻结时间',
						trigger: 'change',
					},
				],
				freezeCurrencyCode: [
					{
						required: true,
						message: '请选择冻结币种',
						trigger: 'change',
					},
				],
				freezeAmount: [
					{
						required: true,
						message: '请输入冻结金额',
						trigger: 'blur',
					},
				],
			},
			formUnfreezeRules: {
				unfreezeTimeString: [
					{
						required: true,
						message: '请选择解冻时间',
						trigger: 'change',
					},
				],

				unfreezeAmount: [
					{
						required: true,
						message: '请输入解冻金额',
						trigger: 'blur',
					},
				],
			},
			freezeRecordDialog: '',
			listStorage: [],
			listSite: [],
			listExchangeRate: [],
			listTable: [],
			page: 1,
			size: 20,
			total: 0,
			action: Baseurl + 'imageController/uploadImage',
			customHeaders: { token: localStorage.getItem('token') },
		}
	},
	computed: {
		isFreezeRecordVisible: {
			get() {
				return ['addRecord', 'thawRecord'].includes(
					this.freezeRecordDialog
				)
			},
			set(value) {
				if (!value) this.freezeRecordDialog = ''
			},
		},
		freezeRecordTitle() {
			const str = this.freezeRecordDialog === 'addRecord' ? '新增' : ''
			return str + '冻结记录'
		},
	},
	created() {
		this.UserInfo = JSON.parse(localStorage.getItem('role'))
		this.getStorage()
		this.getExchangeRate()
		this.getTableList()
	},
	methods: {
		countryChange(item) {
			// console.log(this.listSite)
			// console.log(item)
			let o = this.listSite.filter((otem) => {
				return item == otem.shopId
			})
			// console.log(o)
			this.Chines = o[0].country
			this.formRecord.freezeCurrencyCode = o[0].currencyCode
		},
		getStorage() {
			const API = Baseurl + 'sellerController/findAllSellerByCompanyId'
			const paramsData = {
				company_id: this.UserInfo.company_id,
			}
			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.listStorage = data
				}
			})
		},
		getSite() {
			// const API = Baseurl + "sellerController/findAllCountryMarkBySellerId";
			const API =
				Baseurl + 'sellerController/findFineCountryMarkBySellerId'

			const paramsData = {
				id: this.formRecord.sellerId,
			}
			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.listSite = data
				}
			})
		},
		getExchangeRate() {
			const API = Baseurl + 'rateController/getAllRate'
			ajaxPost(API).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.listExchangeRate = data
				}
			})
		},
		getTableList() {
			const API = Baseurl + 'creditCardController/getFreezeRecordList'
			const paramsData = {
				page: this.page,
				size: this.size,
				searchString: this.formScreen.searchString,
				companyId: this.UserInfo.company_id,
			}
			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.listTable = data.list
					this.total = data.total
				}
			})
		},
		reset(formName) {
			this.$refs[formName].resetFields()
			this.getTableList()
		},
		handleSizeChange(event) {
			this.size = event
			this.getTableList()
		},
		handleCurrentChange(event) {
			this.page = event
			this.getTableList()
		},
		freezeRecordFn(type, row) {
			// console.log(row)
			// console.log(row.unfreezeCurrencyCode)
			this.loading = false
			const operate = {
				addRecord: () => {},
				thawRecord: () => {
					this.formRecord.sellerId = row.shopName || ''
					this.formRecord.countrySellerId = row.countryName || ''
					this.formRecord.freezeAmount = row.freezeAmount || ''
					this.formRecord.freezeTimeString = row.freezeTime || ''
					this.formRecord.freezeCurrencyCode =
						row.freezeCurrencyCode || ''
					this.formRecord.uploadCertificates = JSON.parse(
						row.uploadCertificate
					)
					this.Chines = row.freezeCurrencyCode || ''
					this.formUnfreeze.id = row.id || 0
					this.formUnfreeze.unfreezeAmount = row.unfreezeAmount || ''
					this.formUnfreeze.unfreezeCurrencyCode =
						row.freezeCurrencyCode || ''
					this.formUnfreeze.unfreezeTimeString =
						row.unfreezeTime || ''
					this.formUnfreeze.countrySellerId =
						row.countrySellerId || ''
				},
			}
			this.freezeRecordDialog = type
			const formName =
				this.freezeRecordDialog === 'addRecord'
					? 'formRecord'
					: 'formUnfreeze'
			this[formName] = this.$options.data()[formName]
			this.$nextTick(() => {
				this.$refs[formName].clearValidate()
			})
			operate[type]()
		},
		seletChange(event) {
			this.formRecord.countrySellerId = ''
			this.getSite()
		},
		onSubmit() {
			this.loading = true
			// console.log(this.loading);
			// return;
			const operate = {
				addRecord: () => {
					if (!this.imgList.length) {
						this.$message.warning('请先上传凭证图片')
						this.loading = false
						return
					}

					this.formRecord.uploadCertificates = this.imgList.map(
						(item) => item.response.data
					)
					const API =
						Baseurl + 'creditCardController/insertFreezeRecord'
					const paramsData = {
						freezeRid: this.UserInfo.rid,
						companyId: this.UserInfo.company_id,
						...this.formRecord,
					}
					return ajaxPost(API, paramsData)
				},
				thawRecord: () => {
					const API =
						Baseurl + 'creditCardController/updateFreezeRecord'
					const paramsData = {
						unfreezeRid: this.UserInfo.rid,
						...this.formUnfreeze,
					}
					return ajaxPost(API, paramsData)
				},
			}
			const type = this.freezeRecordDialog
			const formName =
				type === 'addRecord' ? 'formRecord' : 'formUnfreeze'
			this.$refs[formName].validate((valid) => {
				if (valid) {
					operate[type]().then((res) => {
						const { code } = res.data
						if (code === 200) {
							this.$message.success('操作成功')
							this.freezeRecordDialog = ''
							this.dialogImageUrl = ''
							this.imgList = []
							this.getTableList()
							this.$refs.upload.clearFiles()
							this.loading = false
						}
					})
				} else {
					this.loading = false
					return false
				}
			})
		},
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.response.data
			this.dialogVisible = true
		},
		handleSuccess(response, file, fileList) {
			this.imgList = fileList
		},
		handleRemove(file, fileList) {
			this.imgList = fileList
		},
	},
}
</script>

<style lang="scss" scoped>
.FreezeRecords {
	width: 98%;
	.custom-dialog {
		padding: 0 20px;
		.width380 {
			width: 380px;
		}
	}
	.scope_img {
		width: 55px;
		height: 55px;
		margin: 0 auto;
		img {
			width: 100%;
			height: 100%;
		}
	}
}
.prduct_img {
	width: 500px;
	height: 500px;
}
</style>
